import MessagePage from "./pages/MessagePage";

export const messagingRoutes = (prefix = "messages") => [
  {
    name: "Messaging",
    path: `${prefix}`,
    component: MessagePage
  }
];



// WEBPACK FOOTER //
// ./src/features/managements/modules/messaging/routes.js